export const projectDashboardNavQueryKeys = {
  myAssignedProjectContainers: () => ['myAssignedProjectContainers'] as const
};
